import React, { useState } from 'react';
import LogoUploadCard from '../../Settings/Logos/LogoUploadCard.jsx';

const StepLogos = ({ initialLogos, onComplete }) => {
    const [logos, setLogos] = useState(initialLogos || { logo: { exists: false }, weddingLogo: { exists: false } });

    const handleLogoUpload = (data) => {
        setLogos(prev => ({ ...prev, logo: data }));
    };

    const handleWeddingLogoUpload = (data) => {
        setLogos(prev => ({ ...prev, weddingLogo: data }));
    };

    return (
        <div style={{ padding: '1.5rem' }}>
            <p style={{
                fontSize: '0.9375rem',
                color: 'var(--text-secondary, #64748b)',
                marginBottom: '1.5rem',
                lineHeight: '1.6'
            }}>
                Das Logo am besten in JPG oder PNG hochladen. Es sollte eine maximale Seitenlänge
                von 2000px nicht überschreiten. Ist nur ein Logo vorhanden, dieses immer unter
                <strong> Logo</strong> hochladen, da es für Angebote und Rechnungen benötigt wird.
            </p>

            <div className="row g-4">
                <div className="col-md-6">
                    <LogoUploadCard
                        title="Logo"
                        logo={logos.logo}
                        uploadEndpoint="/index.php/settings/logo_update"
                        fieldName="fileupload_logo"
                        onUploadSuccess={handleLogoUpload}
                    />
                </div>
                <div className="col-md-6">
                    <LogoUploadCard
                        title="Hochzeitslogo"
                        logo={logos.weddingLogo}
                        uploadEndpoint="/index.php/settings/weddinglogo_update"
                        fieldName="fileupload_weddinglogo"
                        onUploadSuccess={handleWeddingLogoUpload}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <button
                    onClick={onComplete}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.625rem 1.5rem',
                        border: 'none',
                        borderRadius: '8px',
                        background: 'var(--accent-slate, #5b7c8d)',
                        color: 'white',
                        fontSize: '0.9375rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                >
                    Weiter
                </button>
            </div>
        </div>
    );
};

export default StepLogos;
